import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { keys } from '../lib/queries';
import { R, btnAccent, btnOutline, field, fieldLabelBlock } from '../lib/ui';
import { Modal } from './Modal';

export function NewSheetModal({
  docId, onClose, onCreated,
}: {
  docId: string;
  onClose: () => void;
  onCreated: (tableId: string) => void;
}) {
  const qc = useQueryClient();
  const [label, setLabel] = useState('');

  const create = useMutation({
    mutationFn: () => api.createTable(docId, label.trim()),
    onSuccess: (table) => {
      qc.invalidateQueries({ queryKey: keys.doc(docId) });
      onCreated(table.id);
    },
  });

  const valid = label.trim().length > 0;

  return (
    <Modal title="Новый лист" onClose={onClose}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) create.mutate();
        }}
      >
        <label style={{ ...fieldLabelBlock, marginTop: 0 }}>Название</label>
        <input
          autoFocus
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="National Guard"
          style={field}
        />

        <div style={{ fontSize: 11, color: R.textMuted, marginTop: 6 }}>
          Любое название — с пробелами и кириллицей. Технический идентификатор
          для формул подберётся сам.
        </div>

        {create.isError && (
          <div style={{ marginTop: 12, fontSize: 12, color: R.danger }}>
            {(create.error as Error).message}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
          <button type="button" onClick={onClose} style={btnOutline}>
            Отмена
          </button>
          <button
            type="submit"
            disabled={!valid || create.isPending}
            style={{ ...btnAccent, opacity: !valid || create.isPending ? 0.5 : 1 }}
          >
            {create.isPending ? 'Создаём…' : 'Создать'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
